export default function IconFacebook() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
			<g clipPath="url(#clip0_1810_873)">
				<path
					d="M7.40332 0.203125C11.3797 0.203231 14.6035 3.42693 14.6035 7.40332C14.6034 10.9968 11.9702 13.9754 8.52832 14.5156V9.48438H10.2061L10.5254 7.40332H8.52832V6.05273C8.52845 5.48355 8.80726 4.92787 9.70117 4.92773H10.6094V3.15625C10.6094 3.15625 9.97848 3.04839 9.29297 3.02148L8.99805 3.01562C7.35358 3.01562 6.27851 4.0122 6.27832 5.81641V7.40332H4.4502V9.48438H6.27832V14.5156C2.8363 13.9755 0.203221 10.9969 0.203125 7.40332C0.203125 3.42687 3.42687 0.203125 7.40332 0.203125Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1810_873">
					<rect width="14.4" height="14.4" fill="white" transform="translate(0.203125 0.203125)" />
				</clipPath>
			</defs>
		</svg>
	);
}
